import { useEffect } from 'react';

function useHotjar() {
  useEffect(() => {
    // Add Hotjar tracking script to document head
    const script = document.createElement('script');
    script.src = 'https://t.contentsquare.net/uxa/109c089865eb6.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
}

export default useHotjar;
